import application from 'application/application';

const controller = 'ResetPasswordController';

/* eslint-disable no-unused-vars */

application.controller(controller, [
	'$scope',
	'$http',
	'$state',
	'$stateParams',
	'helper',
	'API',
	($scope, $http, $state, $stateParams, helper, API) => {
		$scope.renderDate = new Date();

		$scope.inputType1 = 'password';
		$scope.inputType2 = 'password';

		$scope.resetPassword = ({ novaSenha, confirmacaoNovaSenha }) => {
			if (!$scope.samePassword) return false;

			$http({
				...helper.http(API.forgotPassword, 'PUT'),
				data: {
					novaSenha,
					confirmacaoNovaSenha,
					chaveRecuperacao: $stateParams.token
				}
			})
				/** @TODO: Alterar o redirecionamento quando solicionar o problema com `stateService.prototype.go`. */
				.then(() => {
					setTimeout(() => {
						$scope.goTo('root.login');
					}, 300);
				});
		};

		const minCharacters = /(^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z]).{8,}$)/;
		const minMedia = /(^[0-9a-zA-Z~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<]{9,})/;
		const minForte = /(^[0-9a-zA-Z~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<]{12,})/;

		$scope.passwordStrength = (senha, confirmacao) => {
			if (senha === undefined) return false;

			if (senha.match(minCharacters.source)) {
				$scope.strength = 'fraca';

				if (senha.match(minForte.source)) {
					$scope.strength = 'forte';
				} else if (senha.match(minMedia.source)) {
					$scope.strength = 'média';
				}
			} else {
				$scope.strength = 'inválida';
			}

			if (confirmacao != undefined) $scope.comparePassword(senha, confirmacao);
		};

		$scope.checkField = senha => {
			if (senha === undefined) $scope.strength = null;
		};

		$scope.comparePassword = (confirmacao, senha) => {
			$scope.samePassword =
				$scope.strength === 'inválida' ? false : senha === confirmacao;

			if (confirmacao === undefined) $scope.samePassword = null;
		};

		$scope.showPassword = num => {
			$scope[`inputType${num}`] =
				$scope[`inputType${num}`] === 'password' ? 'text' : 'password';
		};

		$scope.goTo = routePath =>
			(location.href = $state.get(routePath).url || '/');
	}
]);

export default controller;
